import { useQuery } from '@tanstack/react-query';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import { httpClient } from '@s20/services/httpClient';
import { ApiRoutes } from '../../Common';
import SlideForm from '../../common/forms/SlideForm';
import HistorySection from '../../common/history/HistorySection';

const callLogHistorySection = {
    heading: 'Call Log',
    renderOptions: { formatOffset: true },
};

const CallLogHistoryForm = ({
    id = 'callLogHistoryForm', show, callLogId, onClose,
}) => {
    const { data: callLogHistory, isFetching: loading } = useQuery({
        queryKey: ['callLogHistory', callLogId],
        queryFn: () => httpClient.js(ApiRoutes.callLog.history(callLogId)),
        enabled: show && Boolean(callLogId),
    });

    return (
        <SlideForm
            id={id}
            loading={loading}
            show={show}
            formIcon={faHistory}
            formTitle="Call Log History"
            onClose={onClose}
            saveDisabled
            className="history-form"
        >
            {() => (
                <HistorySection
                    {...callLogHistorySection}
                    historicalChangeCollection={callLogHistory}
                />
            )}
        </SlideForm>
    );
};

export default CallLogHistoryForm;
